<div class="my-container" [hidden]="!loading"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>

<div mat-dialog-title class="matDialogTitle">
 اطلاعات کاربری
 <span>
   <mat-icon class="close" (click)="close()">close</mat-icon>
 </span>
</div>

<form #form_user="ngForm">
  <div mat-dialog-content class="matDialogContent">

        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12 pe'>
          <label for="lname" class='wh-label'>  شماره شبکه اجتماعی   
          <input class='wh-input' name='social_cellphone' [(ngModel)]='social_cellphone'  autocomplete="off">
          </label>
        </div>
        
        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
          <label for="username" class='wh-label'>
            <span>  نام پدر  :</span>   
            <input class='wh-input' name='father' [(ngModel)]='father'   autocomplete="off">
          </label>
        </div> 

        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
            <label for="username" class='wh-label'>
            <span>پست الکترونیک :</span>   
            <input class='wh-input' name='email' [(ngModel)]='email'  autocomplete="off">
            </label>
        </div> 
          
        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
          <label for="username" class='wh-label'>
            <span> سایت :</span>   
            <input class='wh-input' name='web' [(ngModel)]='web'  autocomplete="off">
          </label>
        </div> 

        
        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
          <label for="username" class='wh-label'> شماره ملی 
            <input class='wh-input' name='code_meli' [(ngModel)]='code_meli'   autocomplete="off">
          </label> 
        </div> 
    
        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe' >
          <label for="username" class='wh-label'>  
            <span> تاریخ تولد  :</span>   
            <input class='wh-input' name='birth_date' [(ngModel)]='birth_date'   autocomplete="off">
          </label>
        </div> 
          
        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
          <label for="username" class='wh-label'>
            <span>  فکس   :</span>   
            <input class='wh-input' name='fax' [(ngModel)]='fax'   autocomplete="off">
          </label>
        </div> 

        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
          <label for="username" class='wh-label'>
            <span>   کد پستی   :</span>   
            <input class='wh-input' name='code_post' [(ngModel)]='code_post'   autocomplete="off">
          </label>
        </div> 
    
        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12 pe'>
          <label for="status_admin" class='wh-label'>    
          <span>  مجوز ورود به ادمین  : </span>
            <select class='wh-input' name='status_admin' [(ngModel)]='status_admin'  >
              <option value=1>دارد</option>
              <option value=2>ندارد</option>
            </select>
          </label> 
        </div>

        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
          <label for="status_id" class='wh-label'>    
            <span> وضعیت ورود : </span>
            <select class='wh-input' name='status_id' [(ngModel)]='status_id'>
              <option value='{{ x.status_id }}' *ngFor="let x of list_status">{{ x.status_title }}</option>
            </select>
          </label> 
        </div>

        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe' >
            <label for="status_id" class='wh-label'>    
            <span>  تغییر رمز عبور : </span>
              <select class='wh-input' name='change_pass' [(ngModel)]='change_pass'  >
              <option value=1>بله</option>
              <option value=2>خیر</option>
              </select>
            </label> 
        </div>
        
        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
          <label for="password" class='wh-label'>  رمز عبور    :
            <input type='password' class='wh-input' name='password' [(ngModel)]='password'  [disabled]="change_pass == 2"   autocomplete="off">
          </label>
        </div>
        
        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
          <label for="password" class='wh-label'>  تایید رمز عبور  :
          <input type='password' class='wh-input' name='repassword' [(ngModel)]='repassword' [disabled]="change_pass == 2"  autocomplete="off">
          </label>
        </div>

        <div class='col-lg-2 col-md-2 col-sm-3 col-xs-12  pe'>
          <label for="username" class='wh-label'>
            <span>   ترتیب   :</span>   
            <input class='wh-input' name='sort' [(ngModel)]='sort'   autocomplete="off">
          </label>
        </div>  

  <ngx-smart-modal #modal_attachment_open identifier="myModalAttachment" [customClass]="'medium-modal'" class='pe_select' [ngClass]="{en_select:lang==2}">
    <div class="container"> 
      <div class="row file"> 
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12" style='margin-bottom:14px'>
          <div class='pe'>   
          <span>فایل ها :</span>
          <span style='color:#666;font-size:11px'>برای آپلود فایل خود یا روی باکس پایین کلیک کنید و یا فایل خود را به باکس پایین بکشید</span>
          <span>و برای فعال سازی سایر تنطیمات روی آیکن مقابل کلیک نمائید.</span>
          <span (click)="user_load_file()" style='cursor:pointer'> <i class="fas fa-cogs"></i> </span>
          </div>
        </div><!-- col-md-12 col-lg-12 col-sm-12 col-xs-12 -->
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12"> 
          <form [dropzone]="config"  class="dropzone dz-started" id="my-awesome-dropzone"> 
          <input type="" name="code" value="{{ user }}" style="display:none">
          <input type="" name="username" value="{{ username }}" style="display:none"> 
          <input type="" name="type" value="{{ 5 }}" style="display:none">
          <input type="" name="site" value="{{ site }}" style="display:none">
        
            <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right" *ngFor="let file of list_load_file;let i = index" 
              >  
            <div class="dz-image">
              <a href='{{ file.user_file_site }}/{{ file.user_file_address }}' target="_blank">
              <span *ngIf="file.user_file_type == 'image/jpeg' || file.user_file_type == 'image/gif' ||  file.user_file_type == 'image/png' ">
                <img data-dz-thumbnail="" alt="{{ file.user_file_title }}" src="{{ file.user_file_site }}/{{ file.user_file_address }}" style="max-width:200px !important;width:200px !important">
              </span>
              <span *ngIf="file.user_file_type == 'application/msword' || file.user_file_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                <i class="far fa-file-word icone"></i> 
              </span>
              <span *ngIf="file.user_file_type == 'application/vnd.ms-excel' || file.user_file_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                <i class="fas fa-file-excel icone" style='color:green'></i> 
              </span> 
              <span *ngIf="file.user_file_type == 'application/pdf' ">
                <i class="far fa-file-pdf icone" style='color:red'></i> 
              </span>
              <span *ngIf="file.user_file_type == 'application/zip' ">
                <i class="fas fa-file-archive icone"></i> 
              </span>
              <span *ngIf="file.user_file_type == 'video/mp4' || file.user_file_type == 'video/x-matroska';else other ">
                <i class="fas fa-file-video icone" style='color:black'></i> 
              </span>
              <ng-template #other>
                <i class="fas fa-file-alt icone" style='color:black'></i>    
              </ng-template>
              </a>
            </div><!-- dz-image -->
            <div class="dz-details">    
              <div class="dz-size">
              <span data-dz-size=""><strong>{{ file.user_file_size }}</strong> KB</span>
              </div><!-- dz-size-->      
              <div class="dz-filename">
              <span data-dz-name="" *ngIf="lang == 1" class="pe1">{{ file.user_file_title }}</span>
              </div><!-- dz-filename-->  
            </div>  <!-- dz-detaile-->  
            <div class="dz-progress">
              <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
            </div><!-- dz-progress -->   
            <div class="dz-error-message">
              <span data-dz-errormessage=""></span>
            </div><!-- dz-error-message -->    
          </div><!-- dz-preview dz-processing dz-image-preview dz-success dz-complete -->
          </form><!-- dropzone dz-started -->
        </div><!-- col-md-12 -->
        </div><!-- row file -->
    </div>
  </ngx-smart-modal>
  </div><!-- content -->

  <div mat-dialog-actions class="matDialogActions">
    <button (click)="update()" [disabled]="!form_user.valid">ویرایش</button>
    <button (click)="open_detaile()" [disabled]="!form_user.valid">پیگیری</button>
  </div>
</form>